import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ViewportScroller} from '@angular/common';
import {MatBottomSheet} from '@angular/material/bottom-sheet';
import {CancelBottomSheetComponent} from '../cancel-bottom-sheet/cancel-bottom-sheet.component';
import {ActivatedRoute, Router} from '@angular/router';
import {Store} from '@ngrx/store';
import {IAppointment, AppointmentType, AppointmentStatus} from '@signal/asp-data-commons';
import {Observable} from 'rxjs';
import { countryCd, imageBaseURL, unsubscribeSubscriptions } from '../../../shared/services/util.service';
import { AppointmentService } from '../../../shared/services/appointment.service';
import { DealerState } from '../../../store/dealer/dealer.reducer';
import * as fromSelectors from '../../../store/dealer/dealer.selectors';
import {setDefaultImg} from './../../../shared/services/util.service'
import { transportOptRemote } from '../../../store/settings/settings.selectors';
import { SettingsState } from '../../../store/settings/settings.reducer';
import { AppointmentFormService } from '../../service-appointment/appointment-form.service';
import { SubscriptionList } from '../../../shared/models/asp.types';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.scss']
})
export class ConfirmationComponent implements OnInit, OnChanges, OnDestroy {
  @Input() carImage = '/config/pub/3d/toyota/1006410/1000870/Exterior/3/1200_663_PNG/5f20d79-34590b1-9437dad-5cf1819-8942d14-105a308-25b1b67-2ec34e5-77f04a3-8bfecb5-a0034b0.png';
  @Input() appointment: IAppointment;
  @Input() makeModelYear: string;
  @Input() detailMap: { [key: string]: string };
  @Input() view: string;
  registerUrl = '';
  returnTo = 'bdc-dashboard';
  signedIn = true;
  setDefaultImg=setDefaultImg;
  subs: SubscriptionList = {};
  from = "";
  baseImageUrl: string;
  dealerPhone$: Observable<string>;
  dealerName$: Observable<string>;

  constructor(private readonly viewportScroller: ViewportScroller,
              private readonly bottomSheet: MatBottomSheet,
              private readonly router: Router,
              private readonly activatedRoute: ActivatedRoute,
              private readonly appointmentService: AppointmentService,
              private readonly dealerState: Store<DealerState>,
              private readonly settingState: Store<SettingsState>,
              private readonly appointmentFormService: AppointmentFormService,
              private readonly translate : TranslateService) {
     this.baseImageUrl = imageBaseURL;
    this.dealerName$ = this.dealerState.select(fromSelectors.selectDealerName);
    this.dealerPhone$ = this.dealerState.select(fromSelectors.selectDealerPhoneNumber);
    this.subs.query = this.activatedRoute.queryParams.subscribe(params => {
      this.from = params.from
      if(params.navigateTo){
        this.returnTo = params.navigateTo;
      }
    })
    this.subs.transportOptRemote = this.settingState.select(transportOptRemote).subscribe(res =>{
      if(res && res.cost){
        this.appointmentFormService.setCostAndFlatRateHrsForCompEligibleRental(res.cost,res.flatRateHours);
      }
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.hasOwnProperty(('appointment'))) {
     this.carImage = this.view==='confirm' ? this.appointment?.vehicle?.imageUrl : this.carImage;
    }
  }

  ngOnInit(): void {
    this.viewportScroller.scrollToPosition([0, 0]);
  }

  getDetailKeys() {
    if (this.detailMap) {
      let keys = Object.keys(this.detailMap);
      if(this.from === 'sendLink'){
        keys = keys.filter(k => k != 'service.time')
      }
      return keys
    }
  }

  getTranslation(key:string){
    if(!key || !this.detailMap[key]) {
      return '';
    }
    if(key === 'service.transportation') {
      this.detailMap[key] = this.translate.instant(this.detailMap[key]);
    }
    const value = this.detailMap[key];
    let translatedValue: string = value;
    if(value && value.includes('\n')){
      translatedValue = this.addressShort(value);
    }
    if(translatedValue){
      translatedValue = translatedValue.replace('Starts at', this.translate.instant('opcodeServiceManagement.startsAt'));
      translatedValue = translatedValue.replace('Ranges from', this.translate.instant('opcodeServiceManagement.rangesFrom'));
      translatedValue = translatedValue.replace('service.lexusComplimentaryMaintenance', this.translate.instant('service.lexusComplimentaryMaintenance'));
      translatedValue = translatedValue.replace('service.toyotaComplimentaryMaintenance', this.translate.instant('service.toyotaComplimentaryMaintenance'));
      translatedValue = translatedValue.replace('service.coveredByToyotaCare', this.translate.instant('service.coveredByToyotaCare'));
      translatedValue = translatedValue.replace('Ask Advisor', this.translate.instant('opcodeServiceManagement.askAdvisor'));
    }
    return translatedValue;
  }

  addressShort(value:string) {
    const address:string[]=value?.split('\n');
    let translatedAddress="";
    address.forEach((item)=>{
      if(item && item.includes(':'))
    {
      const fields: string[] = item?.split(':');
      let splittedAddress = '';
      fields.forEach((field)=>{
        splittedAddress+= (field ? this.translate.instant(field) : field) + ':';
      })
      translatedAddress += splittedAddress.slice(0, -1)+ '\n';
    }
    else{
      translatedAddress += (item ? this.translate.instant(item) : item)+ '\n';
    }
     }) 
     return translatedAddress.slice(0,-1);
  }

  getAppointmentSummaryMsg(appointmentType, appointmentStatus,emailAddress) {
    if(appointmentStatus === 'SavedForLater'){
      return `${this.translate.instant('serviceSchedule.linkSentToCustomerAt')} ${emailAddress}`;
    }
    const transObj = {
      "Test Drive": 'serviceSchedule.testDrive',
      "Service": 'serviceSchedule.service',
      "Delivery": 'serviceSchedule.delivery',
      "Learning": 'serviceSchedule.learning',
      "Vehicle Inquiry": 'serviceSchedule.vehicleInquiry',
      "Parts": 'serviceSchedule.parts'
    }
    if(!transObj[appointmentType]) {
      return `${this.translate.instant('testDrive.appointmentSummary')}`;
    }

    return `${this.translate.instant(transObj[appointmentType])} ${this.translate.instant('testDrive.appointmentSummary')}`;
  }
  
  onEdit() {
    if (this.appointment.appointmentType === AppointmentType.TEST_DRIVE) {
      this.router.navigate(['asp/bdc/testdrive'], this.addQueryParam());
    } else if (this.appointment.appointmentType === AppointmentType.SERVICE) {
     // this.serviceAppointmentState.dispatch(new EditServiceAppointmentFromConfirm());
      this.router.navigate(['asp/bdc/service'], this.addQueryParam());
    } else if (this.appointment.appointmentType === AppointmentType.DELIVERY) {
      this.router.navigate(['asp/bdc/delivery'], this.addQueryParam());
    } else if (this.appointment.appointmentType === AppointmentType.LEARNING) {
      this.router.navigate(['asp/bdc/tech-appointment'], this.addQueryParam());
    }else if (this.appointment.appointmentType === AppointmentType.VEHICLE_INQUIRY) {
      this.router.navigate(['asp/bdc/vehicleinquiry'], this.addQueryParam());
    } else if (this.appointment.appointmentType === AppointmentType.PARTS) {
      this.router.navigate(['asp/bdc/parts'], this.addQueryParam());
    }
  }

  addQueryParam() {
    return {
      // relativeTo: this.activatedRoute,
      queryParams: {
        id: this.appointment.appointmentId
      }
    };
  }

  onCancel(): void {
    const bottomSheetRef = this.bottomSheet.open(CancelBottomSheetComponent);
    this.subs.bottomSheetRef = bottomSheetRef.afterDismissed().subscribe((dataFromChild) => {

      if (dataFromChild === 'yes') {
        this.subs.cancel = this.appointmentService.cancel(this.appointment).subscribe((data) => {
            this.router.navigateByUrl('asp/bdc/dashboard');
        });
      }
    });
  }

  onManage(route: string) {
      this.router.navigateByUrl(route);
  }
  ngOnDestroy() {
    unsubscribeSubscriptions(this.subs);
  }
  getApptStatusTranslation(key,value){
  value = value?.replace(' ','');
  return value ? this.translate.instant(`${key}.${value?.toLowerCase()}`) : value;
  }
}
